<template>
  <component :is="component" :language="language" />
</template>

<script>
import Types from './Types'
import { Capitalize } from '@/utils'

export default {
  props: {
    type: String,
  },
  computed: {
    language() {
      return this.$path('$store.state.enums.Language')
    },
    component() {
      return Types[Capitalize(this.type)]
    },
  },
}
</script>
